/**
 * El botón principal de cada pantalla de Compite con el degradado de Prixia
 * (`bg-degradado-prixia`, en tailwind.config.js), como los de la maqueta.
 * Uno por pantalla: lo que se hace primero ahí («Nueva regla», «Crear una
 * estrategia», «Aprobar», «Siguiente» en los asistentes). En oscuro el texto va
 * en `foreground` (claro): el `primary-foreground` del tema oscuro es oscuro.
 */
export const BOTON_DEGRADADO =
  'border-0 bg-degradado-prixia text-primary-foreground shadow-md transition-[filter,box-shadow] hover:brightness-110 hover:shadow-lg dark:text-foreground';
